import type { ColloStato as Collo } from "../api";
import { StepBadge } from "./StepBadge";

function quando(iso: string | null): string {
  if (!iso) return "—";
  return new Date(iso).toLocaleString("it-IT", {
    day: "2-digit",
    month: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
  });
}

/** Stato di ogni collo: con Bracchi un collo può essere consegnato e l'altro
 *  no. Prima ciò che è fermo (PRODUCT.md): i colli non consegnati salgono in
 *  cima, e il badge colorato del passaggio fa spiccare giacenza e
 *  restituzione. Il testo del corriere resta accanto solo se dice di più. */
export function ColliStato({ colli }: { colli: Collo[] }) {
  // ``sort`` e' stabile: dentro ogni gruppo resta l'ordine dei colli.
  const ordinati = [...colli].sort((a, b) => Number(a.consegnato) - Number(b.consegnato));
  return (
    <section className="text-ink">
      <h4 className="mb-1.5 text-[12.5px] font-extrabold">Colli ({colli.length})</h4>
      <table className="w-full text-[12.5px]">
        <thead>
          <tr className="border-b border-line text-left">
            <th className="py-1 pr-3 font-bold">Collo</th>
            <th className="py-1 pr-3 font-bold">Stato</th>
            <th className="py-1 font-bold">Ultima scansione</th>
          </tr>
        </thead>
        <tbody>
          {ordinati.map((c) => (
            <tr key={c.codice} className="border-b border-line align-top last:border-0">
              <td className="py-1.5 pr-3 font-mono">{c.codice}</td>
              <td className="py-1.5 pr-3">
                <span className="flex flex-wrap items-center gap-x-2 gap-y-0.5">
                  {/* Passaggio non mappato (o «Mancata consegna», di proposito
                      senza passaggio): basta il testo del corriere, il badge
                      «Non tracciata» lo contraddirebbe. */}
                  {c.step || !c.stato ? <StepBadge step={c.step} /> : null}
                  {c.stato && c.stato.toLowerCase() !== c.step.toLowerCase() ? (
                    <span>{c.stato}</span>
                  ) : null}
                </span>
              </td>
              <td className="py-1.5 tabular-nums">{quando(c.ultimo_evento)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </section>
  );
}
